export default __webpack_public_path__ + "static/media/bubble.8cc9a184.png";